export const enum AddItemKey {
  box = "box",
  hstack = "hstack",
  vstack = "vstack",
  ul = "ul",
  ol = "ol",
  li = "li",
  columns = "columns",
  grid = "grid",
  section = "section",
  stack = "stack",
  text = "text",
  image = "image",
  icon = "icon",
  link = "link",
  linkContainer = "linkContainer",
  button = "button",
  textbox = "textbox",
  textarea = "textarea",
  password = "password",
  heading = "heading",
  screenFrame = "screenFrame",
  componentFrame = "componentFrame",
  pageFrame = "pageFrame",
}

export const enum WrapItemKey {
  hstack = "hstack-wrap",
  vstack = "vstack-wrap",
}
